/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyResourceRecommendationPolicyIdsQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyResourceRecommendationPolicyIdsQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyResourceRecommendationPolicyIdsQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyResourceRecommendationPolicyIdsQueryOperator>): PolicyResourceRecommendationPolicyIdsQueryOperator {
        let obj = Object.assign(new PolicyResourceRecommendationPolicyIdsQueryOperator(), model);
        PolicyResourceRecommendationPolicyIdsQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyResourceRecommendationPolicyIdsQueryOperator>): PolicyResourceRecommendationPolicyIdsQueryOperator {
        if (!model) return null;
        return PolicyResourceRecommendationPolicyIdsQueryOperator.newInstance(<PolicyResourceRecommendationPolicyIdsQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyResourceRecommendationPolicyIdsQueryOperator) {
        if (!obj) return;

        models.PolicyResourceRecommendationPolicyIdsQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyResourceRecommendationPolicyIdsQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyResourceRecommendationPolicyIdsQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy ID(s) to include
     */
    policy_ids: Array<string>;

}
